import { Container } from '../../../../../../../components/container/container';
import { Modal, ModalProps } from '../../../../../../../components/modal/modal';
import { Select } from '../../../../../../../components/select/select';
import { useLang } from '../../../../../../../hooks/use-lang';
import { ShiftNotificationsType } from '../../../../../../../store/api/company-api';
import { useCompanyStore } from '../../../../../../../store/use-company-store';
import { IdValue } from '../../../../../../../types/props';
import s from './shifts-controls-settings-modal.module.css';

const possibleDelays: IdValue[] = [
  {
    id: '0',
    value: 'Нет',
  },
  {
    id: '1',
    value: '1',
  },

  {
    id: '5',
    value: '5',
  },
  {
    id: '10',
    value: '10',
  },
  {
    id: '15',
    value: '15',
  },
  {
    id: '20',
    value: '20',
  },
  {
    id: '25',
    value: '25',
  },
  {
    id: '30',
    value: '30',
  },
];

const seriousDelays: IdValue[] = [
  {
    id: '0',
    value: 'Нет',
  },
  {
    id: '30',
    value: '30',
  },
  {
    id: '45',
    value: '45',
  },
  {
    id: '60',
    value: '60',
  },
];

export const ShiftsControlsSettingsModal = (props: ModalProps) => {
  const { t } = useLang();
  const { companyProfile, handleSaveCompanyProfile, handleUpdateCompanyProfile } =
    useCompanyStore();

  const shiftsNotifications = companyProfile?.notifications?.shifts;

  const handleUpdate = (data: Partial<ShiftNotificationsType>) => {
    handleUpdateCompanyProfile({ notifications: { shifts: { ...shiftsNotifications, ...data } } });
    handleSaveCompanyProfile();
  };

  const localisedPossibleDelays = possibleDelays.map((item) => ({
    ...item,
    value: item.id === '0' ? t(item.value) : `${item.value} ${t('мин')}`,
  }));
  const localisedSeriousDelays = seriousDelays.map((item) => ({
    ...item,
    value: item.id === '0' ? t(item.value) : `${item.value} ${t('мин')}`,
  }));

  return (
    <Modal {...props} className={s.feature} title={t('Настройки уведомлений')}>
      <span className={s.max}>{t('Максимальная величина - 60 минут')}</span>
      <Container label={t('Допустимая задержка до')} isHorizontal>
        <Select
          options={localisedPossibleDelays}
          value={localisedPossibleDelays.find(
            (item) => item.id === String(shiftsNotifications?.possible_delay),
          )}
          onSelect={(e) => handleUpdate({ possible_delay: Number(e.id) })}
        />
      </Container>
      <Container label={t('Серьезное опоздание от')} isHorizontal>
        <Select
          options={localisedSeriousDelays}
          value={localisedSeriousDelays.find(
            (item) => item.id === String(shiftsNotifications?.serious_delay),
          )}
          onSelect={(e) => handleUpdate({ serious_delay: Number(e.id) })}
        />
      </Container>
    </Modal>
  );
};
